export const convertRegExpToString = (pattern: string): string => {
  let result = '';
  const regex = /\\d{(\d+,\d+)}|\\d{(\d+)}|\\d|\\.|./g;

  let match;
  while ((match = regex.exec(pattern)) !== null) {
    if (match[1]) {
      const [, range] = match[1].split(',').map(Number);
      result += '9'.repeat(range);
    } else if (match[2]) {
      result += '9'.repeat(Number(match[2]));
    } else if (match[0] === '\\d') {
      result += '9';
    } else {
      result += match[0].replace('\\', '');
    }
  }

  return result || '9.9';
};
